import { useEffect, useState } from 'react';
import { getMyCaseCount } from 'api/textVisit';

interface ICaseCounts {
    activeCount: number;
    closedCount: number;
    inProgressCount: number;
}

interface CaseCounts extends ICaseCounts {
    totalCount: number;
}

export default function useGetAllCaseCount(): [CaseCounts, boolean, () => void] {
    const [loading, setLoading] = useState(false);
    const [counts, setCounts] = useState<CaseCounts>({
        activeCount: 0,
        closedCount: 0,
        inProgressCount: 0,
        totalCount: 0
    });

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getMyCaseCount();
            if (!result.error) {
                const data: ICaseCounts = result?.data?.data;
                setCounts({
                    activeCount: data.activeCount,
                    closedCount: data.closedCount,
                    inProgressCount: data.inProgressCount,
                    totalCount: data.activeCount + data.closedCount + data.inProgressCount,
                });
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [counts, loading, fetchData];
};
